export default {
  getCompanyClientReview: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/company_client_reviews/getters.js